export const addresses = state => state.addressBook.get('addresses');
export const sapAddresses = state => state.addressBook.get('sapAddresses');
export const mergedAddresses = state => state.addressBook.get('mergedAddresses');
export const sidebarOpen = state => state.addressBook.get('sidebarOpen');
export const editAddress = state => state.addressBook.get('editAddress');
